<template>
  <v-flex xs12 sm12 md12>
    <v-card class="elevation-12">
      <v-data-table
        :headers="headers"
        :items="airlines"
        :search="search"
        class="elevation-1"
        :loading="loading"
        loading-text="Loading airlines... Please wait"
      >
        <template slot="items" slot-scope="props">
          <template v-if="props.item.show">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">
              <v-btn
                :disabled="props.item.childOf != null"
                @click="handleVisibility(props.item.id)"
                >Toggle</v-btn
              >
            </td>
          </template>
          <template v-else>
            <tr>
              I'm invisible
            </tr>
          </template>
        </template>
        <template v-slot:top>
          <v-toolbar flat dark color="primary">
            <v-toolbar-title>Airlines</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-dialog v-model="dialog" max-width="800px">
              <v-toolbar flat dark color="primary">
                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text dark class="primary mb-2" @click="getAirlines"
                  >Reload</v-btn
                >
                <v-btn text dark class="primary mb-2" v-bind="attrs" v-on="on"
                  >New Airline</v-btn
                >
              </template>
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-row>
                        <v-col cols="2">
                          <v-text-field
                            outlined
                            dense
                            v-model="editedItem.iata"
                            :rules="iataRules"
                            label="IATA Code"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="10">
                          <v-text-field
                            outlined
                            dense
                            v-model="editedItem.name"
                            :rules="nameRules"
                            label="Airline"
                          ></v-text-field>

                          <div class="text-center">
                            <v-btn class="primary mr-2" text @click="close"
                              >Cancel</v-btn
                            >
                            <v-btn text :disabled="!valid" @click="save"
                              >Save</v-btn
                            >
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon class="mr-2" @click="editRule(item)"
            >mdi-pencil-box-outline</v-icon
          >
          <v-icon @click="deleteRule(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>
</template>

<script>
import AdminLayout from "@/layouts/AdminLayout.vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_ROOT_API;

export default {
  data: () => ({
    dialog: false,
    valid: true,
    search: "",
    loading: false,
    iataRules: [
      (v) => !!v || "IATA Code is required",
      (v) => v.length == 2 || "IATA Code must be 3 characters",
    ],
    nameRules: [
      (v) => !!v || "Airline name is required",
      (v) => v.length >= 6 || "Airline name must at least 6 characters",
    ],
    headers: [
      {
        text: "IATA Code",
        align: "start",
        sortable: true,
        value: "iata",
        width: "10%",
        fixed: true,
        childOf: 2,
      },
      {
        text: "Airline Name",
        align: "start",
        sortable: true,
        value: "name",
        width: "80%",
        fixed: true,
        childOf: 2,
      },
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "10%",
        fixed: true,
        childOf: 2,
      },
    ],
    items: [
      {
        text: "ID",
        align: "start",
        sortable: true,
        value: "id",
        width: "10%",
        fixed: true,
      },
    ],
    airlines: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      iata: "",
      name: "",
    },
    defaultItem: {
      id: "",
      iata: "",
      name: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Airline" : "Edit Airline";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.$emit(`update:layout`, AdminLayout);
    this.getAirlines();
  },

  methods: {
    handleVisibility(id) {
      this.items.forEach((element, index) => {
        if (element.childOf === id) {
          element.show = !element.show;
        }
      });
    },

    async getAirlines() {
      this.loading = true;
      this.airlines = [];

      // Get From Airport Info
      await firebase
        .firestore()
        .collection("airlines")
        .orderBy("airline")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            var airline = {
              id: doc.id,
              iata: doc.data().iata,
              name: doc.data().airline,
            };
            this.airlines.push(airline);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    },

    async editRule(item) {
      this.editedIndex = this.airlines.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    async deleteRule(item) {
      const index = this.airlines.indexOf(item);
      await this.$vToastify
        .prompt("Are you sure you want to delete this airline?")
        .then((value) => {
          if (value) {
            firebase
              .firestore()
              .collection("airlines")
              .doc(this.airlines[index].id)
              .delete()
              .then(() => {
                this.$vToastify.success(
                  "Airline successfully deleted",
                  "SUCCESS!"
                );
                // Delete from data table
                this.airlines.splice(index, 1);

                this.$vToastify.success(
                  "Fare rule successfully deleted",
                  "SUCCESS!"
                );
                this.loading = false;
              })
              .catch((error) => {
                this.$vToastify.success(
                  "Airline successfully deleted",
                  "SUCCESS!"
                );
                this.loading = false;
              });
          }
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      if (this.editedIndex > -1) {
        if (this.$refs.form.validate()) {
          try {
            await firebase
              .firestore()
              .collection("airlines")
              .doc(this.airlines[this.editedIndex].id)
              .update({
                iata: this.editedItem.iata,
                airline: this.editedItem.name,
              });

            // Update Data Table (Remove old and add updated data)
            this.airlines.splice(this.editedIndex, 1);
            this.airlines.push({
              id: this.editedItem.id,
              iata: this.editedItem.iata,
              name: this.editedItem.name,
            });

            this.$vToastify.success("Airline successfully updated", "SUCCESS!");
            this.loading = false;
          } catch (error) {
            console.error(error);
            this.loading = false;
          }
        }
      } else {
        if (this.$refs.form.validate()) {
          try {
            const docSaved = await firebase
              .firestore()
              .collection("airlines")
              .add({
                iata: this.editedItem.iata,
                airline: this.editedItem.name,
              });

            // Add to data table
            this.airlines.push({
              id: docSaved.id,
              iata: this.editedItem.iata,
              name: this.editedItem.name,
            });
            this.$vToastify.success("Airline successfully created", "SUCCESS!");
            this.loading = false;
          } catch (error) {
            console.error(error);
            this.loading = false;
          }
        }
      }
      this.close();
    },
  },
};
</script>

<style scoped>
.v-btn {
  color: rgb(255, 255, 255) !important;
  background-color: #0b2545 !important;
}
.theme--light.v-btn--disabled {
  color: rgb(255, 255, 255) !important;
  background-color: #b8b8b8 !important;
}
</style>